/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Settings from "./../../modules/settings";
import jwt from "./../../services/jwt";
// import MenuItem from 'antd/lib/menu/MenuItem';
import Accesspage from "./../404";
import TokenGenerator from "../../modules/token/TokenGenerator";
import Biller from "../../modules/biller/Biller";
import Operator from "../../modules/operator/Operator";
// import Reports from "../../modules/Reports/Reports";
import Reports from "../../modules/Reports";
import Technician from "../../modules/technician/Technician";
import QueueListConfig from "../../modules/queueList/QueueListConfig";
import Dashboard from "../../modules/dashboard/Dashboard";
import MasterList from "../../modules/admin/MasterList";
import Queue from "../../modules/queueList/Queue";
import Profile from "../../modules/profile";
import Biller_display from "../../modules/tvScreen";
import TvScreen1 from "../../modules/tvsettings/TvScreen1";
import TvScreen2 from "../../modules/tvsettings/TvScreen2";
import TvScreen3 from "../../modules/tvsettings/TvScreen3";
import OpdTvDisplay from "../../modules/tvsettings/newScreensWithApi/OpdTvDisplay";
import VitalsTvDisplay from "../../modules/tvsettings/newScreensWithApi/VitalsTvDisplay";
import DashboardReports from "../../modules/dashboard/dashboardReports/DashboardReports";
import PatientList from "../../modules/dashboard/dashboardReports/PatientList";
import MsiReports from "../../modules/MIS/MsiReports";
import Mis from "../../modules/MIS/Mis";
const $ = require("jquery");
const slugswithparent = [
  { route: "add-user", parent: "settings", action: "add" },
  { route: "add-doctor", parent: "settings", action: "add" },
  { route: "add-role", parent: "settings", action: "add" },
  { route: "add-units", parent: "settings", action: "add" },
  { route: "add-service-group", parent: "settings", action: "add" },
  { route: "add-departments", parent: "settings", action: "add" },
  { route: "add-services", parent: "settings", action: "add" },
  { route: "addtvscreen", parent: "settings", action: "add" },
  { route: "add-work-stations", parent: "settings", action: "add" },

  { route: "view-user", parent: "settings", action: "view" },
  { route: "view-doctor", parent: "settings", action: "view" },
  { route: "view-role", parent: "settings", action: "view" },
  { route: "view-units", parent: "settings", action: "view" },
  { route: "view-service-group", parent: "settings", action: "view" },
  { route: "view-departments", parent: "settings", action: "view" },
  { route: "view-services", parent: "settings", action: "view" },
  { route: "viewtvscreen", parent: "settings", action: "view" },
  { route: "view-work-stations", parent: "settings", action: "view" },
  

  { route: "edit-user", parent: "settings", action: "edit" },
  { route: "edit-doctor", parent: "settings", action: "edit" },
  { route: "edit-role", parent: "settings", action: "edit" },
  { route: "edit-units", parent: "settings", action: "edit" },
  { route: "edit-service-group", parent: "settings", action: "edit" },
  { route: "edit-departments", parent: "settings", action: "edit" },
  { route: "edit-services", parent: "settings", action: "edit" },
  { route: "edittvscreen", parent: "settings", action: "edit" },
  { route: "edit-work-stations", parent: "settings", action: "edit" },

  { route: "user-details", parent: "settings", action: "view" },
  { route: "tv-screens", parent: "settings", action: "view" },
  // ---------
  { route: "add", parent: "queue-settings", action: "add" },
  { route: "edit", parent: "queue-settings", action: "edit" },
  { route: "view", parent: "queue-settings", action: "view" },
  { route: "add-user", parent: "users", action: "add" },
  { route: "edituser", parent: "users", action: "edit" },
  { route: "addrole", parent: "roles", action: "add" },
  { route: "editrole", parent: "roles", action: "edit" },
  { route: "viewrole", parent: "roles", action: "view" },
  { route: "addtvscreen", parent: "tv-displays", action: "add" },
  { route: "edittvscreen", parent: "tv-displays", action: "edit" },
  { route: "viewtvscreen", parent: "tv-displays", action: "view" },
  { route: "technician-view", parent: "queue-settings", action: "add" },
  { route: "doctor-view", parent: "queue-settings", action: "add" },
  { route: "vitals-view", parent: "queue-settings", action: "add" },
  // { route: "add-work-stations", parent: "work-stations", action: "add" },
  // { route: "edit-work-stations", parent: "work-stations", action: "edit" },
];
class CustomPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }
  componentDidMount() {
    setTimeout(function () {
      if (
        $(".body-container").outerHeight(true) + $("header").outerHeight(true) >
        $(window).height()
      ) {
        $("footer").css({ position: "relative", top: "10px" });
      } else {
        $("footer").css({ position: "relative", top: "unset" });
      }
    }, 100);
  }

  componentWillUnmount() {
    $("footer").css({ position: "relative", top: "unset" });
  }
  getSnapshotBeforeUpdate(prevProps, prevState) {
    return prevProps;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null || snapshot !== undefined) {
      if (snapshot.location.pathname !== this.props.location.pathname) {
      }
    }
  
    setTimeout(function () {
      if (
        $(".body-container").outerHeight(true) + $("header").outerHeight(true) >
        $(window).height()
      ) {
        $("footer").css({ position: "relative", top: "10px" });
      } else {
        $("footer").css({ position: "relative", top: "2.7pc" });
      }
    }, 100);
  }

  BodyRender() {
    const { id, slug } = this.props.match.params;
    // console.log("--------------------" , slug);
    const { menuList } = this.props;
    var page = null;
    let obj = null;
    // console.log("id", id);
    // console.log("menuList this.props", this.props);
    if (menuList.length !== 0) {
      // console.log("menulist..........");
      // console.log("menulist", menuList, id, slug);
      //obj = menuList.find(o => o.route === id);
      if (id !== undefined) {
        obj = menuList.find((o) => {
          if (o.route === id) {
            if (slug !== undefined) {
              let oscheck = o.submenu.find((os) => os.route === slug);
              if (oscheck === undefined) {
                let osm = slugswithparent.find((sm) => sm.route === slug);
                if (osm !== undefined) {
                  let osmcheck = o.submenu.find(
                    (os) => os.route === osm.parent
                  );
                  if (osmcheck !== undefined) {
                    if (
                      osmcheck.permissions.add === "true" &&
                      osm.action === "add"
                    ) {
                      return o;
                    } else if (
                      osmcheck.permissions.edit === "true" &&
                      osm.action === "edit"
                    ) {
                      return o;
                    } else if (
                      osmcheck.permissions.view === "true" &&
                      osm.action === "view"
                    ) {
                      return o;
                    }
                  } else {
                    if (o.permissions.add === "true" && osm.action === "add") {
                      return o;
                    } else if (
                      o.permissions.edit === "true" &&
                      osm.action === "edit"
                    ) {
                      return o;
                    } else if (
                      o.permissions.view === "true" &&
                      osm.action === "view"
                    ) {
                      return o;
                    }
                  }
                }
              }
              return oscheck;
            } else {
              return o;
            }
          }
        });
      }
    }

    if (id === "login") {
      this.props.history.push(`/`);
    }
    if (obj !== null) {
      if (obj !== undefined) {
        switch (id) {
          case "dashboard":
            page = (
              // <Dashboard {...this.props} {...this.state} menuList={menuList} />
              <DashboardReports
                {...this.props}
                {...this.state}
                menuList={menuList}
              />
            );
            break;
          case "queue":
            page = (
              <Queue {...this.props} {...this.state} menuList={menuList} />
            );
            break;
          case "settings":
            page = (
              // <MasterList {...this.props} {...this.state} menuList={menuList} />
              <Settings {...this.props} {...this.state} menuList={menuList} />
            );
            break;
          case "mis-report":
              page = (
                <MsiReports  />
              );
              break;
          case "reports":
            page = (
              <Reports {...this.props} {...this.state} menuList={menuList} />
            );
            break;
          // case "tv-settings":
          //   page = (
          //     <MasterList {...this.props} {...this.state} menuList={menuList} />
          //   );
          //   break;
          case "tv-display":
            page = (
              <Biller_display
                {...this.props}
                {...this.state}
                menuList={menuList}
              />
            );
            break;
          case "opdtvdisplay":
            page = (
              <OpdTvDisplay
                {...this.props}
                {...this.state}
                menuList={menuList}
              />
            );
            break;
          case "vitalstvdisplay":
            page = (
              <VitalsTvDisplay
                {...this.props}
                {...this.state}
                menuList={menuList}
              />
            );
          break;
          default:
            page = <div></div>;
            break;
        }
      } else {
        if (id === "profile") {
          page = (
            <Profile {...this.props} {...this.state} menuList={menuList} />
          );
        } else if (id === "tv-display") {
          page = (
            <Biller_display
              {...this.props}
              {...this.state}
              menuList={menuList}
            />
          );
        } else if (id === "opdtvdisplay") {
          page = (
            <OpdTvDisplay {...this.props} {...this.state} menuList={menuList} />
          );
        } else if (id === "vitalstvdisplay") {
          page = (
            <VitalsTvDisplay
              {...this.props}
              {...this.state}
              menuList={menuList}
            />
          );
        } else if (id !== "dashboard") {
          page = <Accesspage></Accesspage>;
        } else if (id === "dashboard") {
          page = (
            <DashboardReports
              {...this.props}
              {...this.state}
              menuList={menuList}
            />
          );
          return page;
        } else {
          let submenu = null;
          if (menuList[0]["submenu"].length !== 0) {
            submenu = menuList[0]["submenu"][0]["route"];
          }
          if (submenu !== null) {
            this.props.history.push(`/${menuList[0]["route"]}/${submenu}`);
          } else {
            this.props.history.push(`/${menuList[0]["route"]}`);
          }
        }
      }
    } else {
      if (id === "tv-display") {
        page = (
          <Biller_display {...this.props} {...this.state} menuList={menuList} />
        );
      }
      if (id === "opdtvdisplay") {
        page = (
          <OpdTvDisplay {...this.props} {...this.state} menuList={menuList} />
        );
      }
      if (id === "vitalstvdisplay") {
        page = (
          <VitalsTvDisplay
            {...this.props}
            {...this.state}
            menuList={menuList}
          />
        );
      }
    }
    return page;
  }

  render() {
    return (
      <div className="custom-container">
        <div className="container-fluid">{this.BodyRender()}</div>
      </div>
    );
  }
}

export default jwt(CustomPage);
